<template>
  <div class="elasticLoadBalancingResourceSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div>
        <Col span="6" v-if="company == 1">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
        <Col span="6">
          <Input
            v-model="accountName"
            :placeholder="$t('RAM.common.filterByAccountName')"
          />
        </Col>
        <Col span="6">
          <Input
            v-model="loadName"
            :placeholder="$t('RAM.common.filterByLoadName')"
          />
        </Col>
        <Col span="4">
          <Button
            v-hasPermission="[
              'resourceConfigurationManagement:ali:elasticLoadBalancingResourceAli:page'
            ]"
            @click="getData"
            >{{ $t("message.select") }}</Button
          >
        </Col>
      </div>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableElasticLoadBalancingResource from "../elb/TableElasticLoadBalancingResource";
var tableElasticLoadBalancingResource = TableElasticLoadBalancingResource;
export default {
  name: "ElasticLoadBalancingResourceSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
      loadName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableElasticBlockStoreResource.methods.showAll();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("loadName", this.loadName);
      tableElasticLoadBalancingResource.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
      });
    }
  }
};
</script>
<style scoped>
.elasticLoadBalancingResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/elb/ElasticLoadBalancingResourceSearch.vue